import type { Component, Page, Site, PageLayout } from '../../schemas/validation';

export interface WebsitePreviewData {
  website: Site | null;
  page: Page | null;
  components: Component[];
  navigation: Array<{ title: string; slug: string; orderPosition: number }>;
  theme: any;
  layout: PageLayout | null;
  loading: boolean;
  error: string | null;
  /**
   * Whether to show the "Powered by" branding badge.
   * True for FREE tier users, false for paid plans.
   */
  showBranding: boolean;
}

export const INITIAL_PREVIEW_DATA: WebsitePreviewData = {
  website: null,
  page: null,
  components: [],
  navigation: [],
  theme: null,
  layout: null,
  loading: true,
  error: null,
  showBranding: false,
};
